import React, {useState} from "react"

import VScroll from "../../../scrolling/custom-v-scroll/v-scroll"
import SearchInput from "../../../../gd-ui/search/search";
import {EMOJI_CATEGORIES, EmojiIconCategory} from "../../../../gd/const/item-icon/emoji/emoji-categtories";
import EmojiItem from "./emoji-item";
import {EmojiDict} from "../../../../gd/const/item-icon/emoji/emoji";
import {IconSelectorProps} from "../icon-selector";

// const debug = "EmojiTab_Content"
const debug = false

export default function EmojiTab_Content(props:IconSelectorProps) {

    const [searchQuery, setSearchQuery] = useState<string>('')
    const [searchResult, setSearchResult] = useState<EmojiIconCategory[]>(EMOJI_CATEGORIES)
    const [icon, setIcon]   = useState<string|undefined>(props.icon)

    const onEmojiSelect = (emoji: string) => {
        setIcon(emoji)
        props.onChange?.(emoji)
    }

    const onSearch = (query: string)=> {
        setSearchQuery(query)

        if (query.trim().length === 0) {
            setSearchResult(EMOJI_CATEGORIES)
            return
        }

        const searchResult: EmojiIconCategory[] = []

        _.map(EMOJI_CATEGORIES, (category: EmojiIconCategory)=> {

            const filteredIcons: string[] = _.filter(category.emojiIcons, (icon: string)=> {
                return EmojiDict[icon].keyword.toLowerCase().includes(query.toLowerCase())
            })

            if (!_.isEmpty(filteredIcons)) {
                searchResult.push({
                    name        : category.name,
                    emojiIcons  : filteredIcons
                })
            }
        })

        setSearchResult(searchResult)
    }

    debug && console.log(debug, 'render', icon)

    return (
        <>
            <div className="p-10">
                <SearchInput size           = {36}
                             placeholder    = "Search..."
                             value          = {searchQuery}
                             onChange       = {onSearch}/>
            </div>

            {_.isEmpty(searchResult) &&
                <div className="flex-row-center-center ui5-txt-not-important h-100">No results found</div>}

            <VScroll containerClass="ui5-popover-menu max-h-400">
                {_.map(searchResult, (iconCategory: EmojiIconCategory, categoryKey: number) =>
                    <div key={categoryKey}>
                        <div className="ui5-txt-not-important-tiny fw-600 p-h-10">{iconCategory.name}</div>
                        <div className="icons-group">
                            {_.map(iconCategory.emojiIcons, (emoji: string, itemKey: number) => {
                                const classes = Classes("block", {
                                    selected: emoji === icon
                                })

                                return <EmojiItem key           = {itemKey}
                                                  classes       = {classes}
                                                  emoji         = {emoji}
                                                  onEmojiSelect = {onEmojiSelect}/>
                            })}
                        </div>
                    </div>
                )}
            </VScroll>
        </>
    )
}

